import type { IRoutineExecutionRepository, ListExecutionsQuery } from '@yawi/domain';
import { paginateArray } from '@yawi/domain';
import type { RoutineExecution } from '@yawi/types';

const now = Date.now();

const MOCK_EXECUTIONS: RoutineExecution[] = [
  {
    id: 'exec-001',
    jobId: 'routine-001',
    tenantId: 'tenant-demo',
    triggeredBy: 'schedule',
    status: 'success',
    startedAt: new Date(now - 5 * 24 * 60 * 60 * 1000).toISOString(),
    finishedAt: new Date(now - 5 * 24 * 60 * 60 * 1000 + 4500).toISOString(),
    durationMs: 4500,
    resultCount: 145,
    attempt: 1,
  },
  {
    id: 'exec-002',
    jobId: 'routine-001',
    tenantId: 'tenant-demo',
    triggeredBy: 'manual',
    status: 'success',
    startedAt: new Date(now - 10 * 24 * 60 * 60 * 1000).toISOString(),
    finishedAt: new Date(now - 10 * 24 * 60 * 60 * 1000 + 3800).toISOString(),
    durationMs: 3800,
    resultCount: 143,
    attempt: 1,
  },
  {
    id: 'exec-003',
    jobId: 'routine-001',
    tenantId: 'tenant-demo',
    triggeredBy: 'schedule',
    status: 'failed',
    startedAt: new Date(now - 35 * 24 * 60 * 60 * 1000).toISOString(),
    finishedAt: new Date(now - 35 * 24 * 60 * 60 * 1000 + 500).toISOString(),
    durationMs: 500,
    resultCount: 0,
    errorMessage: 'No se pudieron generar cargos: la configuración de cuota no está activa.',
    attempt: 1,
  },
  {
    id: 'exec-004',
    jobId: 'routine-001',
    tenantId: 'tenant-demo',
    triggeredBy: 'retry',
    status: 'success',
    startedAt: new Date(now - 35 * 24 * 60 * 60 * 1000 + 60000).toISOString(),
    finishedAt: new Date(now - 35 * 24 * 60 * 60 * 1000 + 64200).toISOString(),
    durationMs: 4200,
    resultCount: 143,
    attempt: 2,
  },
  {
    id: 'exec-005',
    jobId: 'routine-002',
    tenantId: 'tenant-demo',
    triggeredBy: 'schedule',
    status: 'success',
    startedAt: new Date(now - 1 * 24 * 60 * 60 * 1000).toISOString(),
    finishedAt: new Date(now - 1 * 24 * 60 * 60 * 1000 + 1200).toISOString(),
    durationMs: 1200,
    resultCount: 23,
    attempt: 1,
  },
  {
    id: 'exec-006',
    jobId: 'routine-003',
    tenantId: 'tenant-demo',
    triggeredBy: 'schedule',
    status: 'failed',
    startedAt: new Date(now - 2 * 24 * 60 * 60 * 1000).toISOString(),
    finishedAt: new Date(now - 2 * 24 * 60 * 60 * 1000 + 800).toISOString(),
    durationMs: 800,
    resultCount: 0,
    errorMessage: 'Conexión a la base de datos interrumpida.',
    attempt: 1,
  },
];

export class MockRoutineExecutionRepository implements IRoutineExecutionRepository {
  async list(query?: ListExecutionsQuery) {
    let items = [...MOCK_EXECUTIONS];

    if (query?.jobId) {
      items = items.filter(e => e.jobId === query.jobId);
    }
    if (query?.status) {
      items = items.filter(e => e.status === query.status);
    }
    if (query?.from) {
      items = items.filter(e => e.startedAt >= query.from!);
    }
    if (query?.to) {
      items = items.filter(e => e.startedAt <= query.to!);
    }

    items.sort((a, b) => b.startedAt.localeCompare(a.startedAt));
    return paginateArray(items, query?.page ?? 1, query?.limit ?? 20);
  }

  async findById(executionId: string) {
    return MOCK_EXECUTIONS.find(e => e.id === executionId) ?? null;
  }
}
